!function(c){Drupal.behaviors.productAccordion={attach:function(o,n){c(".product-full__accordion__container",o);var i={titles:c(".js-accordion__title",o),panels:c(".js-accordion__panel",o)};new site.BasicAccordion(i)}}}(jQuery);
//# sourceMappingURL=product_accordion_v1.js.map
